import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import authApi from "../../data/api/authApi";
import { useLanguage } from "../helpers/LanguageContext";
import "../../css/Register.css";

const Register = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const [userName, setUserName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (password !== repeatPassword) {
      setErrorMessage(t("registerPasswordMismatch"));
      return;
    }

    try {
      await authApi.registerApi({
        userName,
        name,
        email,
        address,
        password
      });

      setSuccessMessage(t("registerSuccess"));
      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      setErrorMessage(t("registerError"));
      console.error("Register error:", error);
    }
  };

  return (
    <Container fluid className="register-page">
      <div className="register-card shadow-sm">
        <form className="register-form" onSubmit={handleRegister}>
          <h3 className="register-title">{t("register")}</h3>

          {errorMessage && (
            <div className="alert alert-danger register-alert">
              {errorMessage}
            </div>
          )}

          {successMessage && (
            <div className="alert alert-success register-alert">
              {successMessage}
            </div>
          )}

          <div className="register-grid">
            <div className="register-field">
              <label className="form-label">{t("name")}</label>
              <input
                type="text"
                className="form-control register-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="register-field">
              <label className="form-label">{t("username")}</label>
              <input
                type="text"
                className="form-control register-input"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>

            <div className="register-field">
              <label className="form-label">{t("email")}</label>
              <input
                type="email"
                className="form-control register-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="register-field">
              <label className="form-label">{t("address")}</label>
              <input
                type="text"
                className="form-control register-input"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </div>

            <div className="register-field">
              <label className="form-label">{t("password")}</label>
              <input
                type="password"
                className="form-control register-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="register-field">
              <label className="form-label">{t("repeatPassword")}</label>
              <input
                type="password"
                className="form-control register-input"
                value={repeatPassword}
                onChange={(e) => setRepeatPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="d-grid gap-2 register-actions">
            <Button type="submit" className="register-submit-btn">
              {t("register")}
            </Button>

            <Button
              variant="link"
              className="register-link-btn"
              onClick={() => navigate("/login")}
            >
              {t("backToLogin")}
            </Button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default Register;
